"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GLSquareCropRotatePipeline = void 0;

var _GLFilterPipeline = _interopRequireDefault(require("./GLFilterPipeline"));

var _GLSquareCropRotateFilter = _interopRequireDefault(require("./GLSquareCropRotateFilter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class GLSquareCropRotatePipeline extends _GLFilterPipeline.default {
  constructor(filters = []) {
    const cropRotateFilter = new _GLSquareCropRotateFilter.default();
    super([cropRotateFilter].concat(filters));
    this.cropFilter = cropRotateFilter;
  }

  setScale(value) {
    this.cropFilter.setScale(value);
  }

  getScale() {
    return this.cropFilter.getScale();
  }

  setOffset(value) {
    this.cropFilter.setOffset(value);
  }

  setRotation(value) {
    this.cropFilter.setRotation(value);
  }

  getRotation() {
    return this.cropFilter.getRotation();
  }

  drawOffScreen(gl, texture, viewWidth, viewHeight, textureWidth, textureHeight, flip) {
    const length = Math.min(viewWidth, viewHeight);
    return super.drawOffScreen(gl, texture, length, length, textureWidth, textureHeight, flip);
  }

}

exports.GLSquareCropRotatePipeline = GLSquareCropRotatePipeline;

var _default = new GLSquareCropRotatePipeline();

exports.default = _default;